import React from 'react'
import API from '../../api';
import Plyr from 'plyr-react'
import 'plyr-react/plyr.css'

class AnimeStream extends React.Component{
    constructor(props){
        super(props)
        this.props = props;
        this.state = {
            count : 0,
            onloaded : false,
            title: "Loading",
            source : {
                type:"video",
                sources: [
                    {
                        src: "/img/blank.mp4",
                        type: "video/mp4",
                        size:360
                    }
                ],
                poster: "/img/kaguya.png"
            },
            cloudflare_block: false,
            external_source: false,
            external:[],
            source_external: "",
            mega: {}
        }
        this.defaultPlyrOptions = Plyr.defaultProps.options
        this.defaultPlyrOptions.autoplay = true
        this.player = React.createRef()
    }

    async onloading(){
        let point = "";
        for(let i = 0; i < this.state.count; i++){
            point = point + ".";
        }
        this.setState({
            count: this.state.count + 1
        })
        if(this.state.count > 3){
            this.setState({
                count: 0
            })
        }
        if(!this.state.onloaded){
            this.setState({
                title: "Loading "+point
            })
            setTimeout(() => {
                this.onloading()
            }, 1000)
        }
    }

    async sourceGet(){
        this.onloading()
        let sources = []
        let getstreamdata = await fetch(API.getstreamdata+this.props.epsid).then((res) => res.json())
        let title = getstreamdata.data.title
        let cloudflare_block = false
        let getstream = getstreamdata.data.stream
        let mega = {
            data: getstreamdata.data.mega
        }
        let external = []

        for(let i = 0; i < getstream.length; i++){
            if(/embed/.test(getstream[i].stream)){
                cloudflare_block = true
                external.push({
                    quality: getstream[i].quality,
                    stream: getstream[i].stream
                })
            }
            else{
                let s = {
                    src: getstream[i].stream,
                    type: "video/mp4",
                    size: getstream[i].quality
                }
    
                sources.push(s)
            }
        }

        this.setState({
            onloaded : true,
            title: title,
            source: {
                type: "video",
                title: {title},
                sources: sources,
                poster: "/img/kaguya.png"
            },
            cloudflare_block: cloudflare_block,
            external: external,
            mega: mega
        })

        console.log(this.state)
    }

    async legacysourceGet(){
        fetch(API.getmega+this.props.epsid).then((res) =>{
            return res.json()
        }).then((json) =>{
            this.setState({
                mega: json
            })
        })

        this.onloading()
        let sources = []
        let getstream = await fetch(API.getstream+this.props.epsid).then((res) => res.json())
        let title = await fetch(API.gettitle+this.props.epsid).then((res) => res.json())
        title = title.data.title

        getstream = await getstream.data

        for(let i = 0; i < getstream.length; i++){
            let s = {
                src: getstream[i].stream,
                type: "video/mp4",
                size: getstream[i].quality
            }

            sources.push(s)
        }

        this.setState({
            onloaded : true,
            title: title,
            source: {
                type: "video",
                title: {title},
                sources: sources,
                poster: "/img/kaguya.png"
            }
        })
    }

    show_external(){
        this.setState({
            source_external: this.state.external[0].stream,
            external_source: true,
        })
    }
    changeSource(external){
        this.setState({
            source_external: external,
        })
    }

    componentDidMount(){
        if(localStorage.getItem("server") === "https://nontonanime.thedark38.repl.co"){
            this.legacysourceGet()
        }else{
            this.sourceGet()
        }
    }

    /*
    {this.state.videourl === "" ? "" : (
                    <video className="w-10/12" controls>
                        <source src={this.state.videourl}></source>
                    </video>)}
    */

    render(){
        return (
            <>
            <div className="bg-slate-800 rounded-md w-full pt-3 px-3 md:pt-10 md:px-10 col-span-12 mt-3 sm:mt-0">
                <div className="block">
                    <a href={"/"}>
                        <button className="bg-zinc-700 text-white p-3 rounded-md mb-3">
                            Kembali
                        </button>
                    </a>
                </div>
                <p className="text-white text-lg mb-5">{this.state.title}</p>
                <div className={this.state.cloudflare_block? "hidden": "block w-full mb-2"}>
                    <Plyr ref={(player) => (this.player.current = player)} {...{source: this.state.source, options: this.defaultPlyrOptions}}/>
                </div>
                <div className={this.state.cloudflare_block? this.state.external_source? "hidden" : "block w-full mb-2 bordereps p-10": "hidden"}>
                    <p className="text-white">Akses Video Terblokir Oleh Cloudflare, Apakah ingin embed ke situs eksternal ? Iklan mungkin saja akan muncul jika embed ke situs eksternal</p>
                    <button className="rounded-md bg-blue-500 px-5 py-2" onClick={this.show_external.bind(this)}>Ya, Embed ke situs eksternal</button>
                </div>
                {this.state.cloudflare_block? this.state.external_source? (
                <div className="block w-full mb-2">
                    <iframe src={this.state.source_external} title={this.state.source_external} className="w-full aspect-video mb-2" allowFullScreen={true}>
                    </iframe>
                    {this.state.external.map((d) => (
                        <>
                            <button className="rounded-md bg-blue-500 px-5 py-2 mr-3" onClick={this.changeSource.bind(this, d.stream)}>{d.quality}</button>
                        </>
                    ))}
                </div>) : 
                (<></>) : (<></>)}
                <div className="block mb-9">
                    {this.state.mega.hasOwnProperty("data") ? (
                       <>
                        
                            <>
                                <p className="text-white">Stream Lainnya</p>
                                <table className="w-full">
                                    <tbody>{this.state.mega.data.map((data, index) => (
                                        <tr key={index}>
                                            <td className='text-white'>
                                                {data.quality+"p"}
                                            </td>
                                            <td>
                                                <a href={data.stream} className="text-white" target="blank">Link</a>
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>
                        
                       </>
                    ): (
                        <>
                        </>
                    )}
                </div>
            </div>
            </>
        )
    }
}

export default AnimeStream;